import { render, staticRenderFns } from "./AdminAddUser.vue?vue&type=template&id=530d8b9c&"
import script from "./AdminAddUser.vue?vue&type=script&lang=js&"
export * from "./AdminAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports